const fbId = '535992757265440'

export const createFBShareLink = (urlLink) => {
  const url = 'http://www.facebook.com/dialog/share?app_id=' + fbId +
    '&href=' + encodeURIComponent(urlLink) +
    '&display=popup';

  return url;
}
